import { useHistory } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";

const Home = () => {
  let history = useHistory();
  return (
    <div>
      <center>
        <Typography variant="h4" component="h4">
          Welcome to your own Router installation
        </Typography>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={() => {
            history.push("/scancode");
          }}
          style={{
            fontSize: "30px",
            textAlign: "center",
            marginTop: "100px",
          }}
        >
          Proceed
        </Button>
      </center>
      <div class="vp-btm">
        <iframe
          height="300px"
          src="https://c0851a8789cb4de4999016bd86ebb439.us-east-1.sumerian.aws/"
          title="screen1"
          style={{
            border: "none",
          }}
        ></iframe>
      </div>
    </div>
  );
};

export default Home;
